import { Component, OnInit, EventEmitter, Output, Input, OnChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ValidationService } from 'projects/services/src/app/validation.service';
import { FORM_STATE } from '../forms/link-trainer/link-trainer.component';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { SharedService } from 'projects/services/src/app/shared/shared.service';

@Component({
	selector: 'app-facility-select-upload-adding-tc',
	templateUrl: './facility-select-upload-adding-tc.component.html',
	styleUrls: ['./facility-select-upload-adding-tc.component.css']
})
export class FacilitySelectUploadAddingTcComponent implements OnInit, OnChanges {
	localFileName: any = {};
	facilitySelectUploadForm: FormGroup;
	@Output() valueChange = new EventEmitter();
	@Output() validChange = new EventEmitter();
	@Input() disable = false;
	@Input() state = FORM_STATE.FILLING;
	@Input() validationCheck = false;
	@Input() defaultValue: any = {};
	@Input() requiredFacilites: any = {}
	@Input() showAstrisk = true;
	@Input() checkBoxes: {
		label: string,
		name: string,
		documentName: string,
		errorName: string,
		required: boolean,
	}[] = []
	@Input() options
	// = [
	// 	'internalConnectivity',
	// 	'avVideoConFacility',
	// 	'library',
	// 	'staffRoom',
	// 	'cafetariaDiningRoom',
	// 	'physicalDisabledFriendly',
	// 	'parkingFacility',
	// 	'threePhasePowerConnection',
	// 	'powerBackupFacility',
	// 	'fireSafetyEquipment',
	// 	'firstAidKitAvailability',
	// 	'counsellingRoomPlacementCell',
	// 	'residentialTraining',
	// 	'cctvFacility',
	// 	'biometricTrainingAttendance',
	// 	'nsdcBranding',

	// ]

	constructor(
		private formBuilder: FormBuilder,
		private sharedService: SharedService
	) {
	}

	patchValue(defaultValue) {
		if (!defaultValue) {
			return;
		}
		const documents = {};
		const checkboxes = {};
		Object.keys(defaultValue).map(key => {
			if (key.includes('Document')) {
				documents[key] = defaultValue[key];
			} else {
				checkboxes[key] = defaultValue[key];
			}
		})
		this.facilitySelectUploadForm.patchValue(checkboxes);
		setTimeout(() => this.facilitySelectUploadForm.patchValue(documents));
	}

	ngOnInit() {
		this.requiredFacilites = this.requiredFacilites || {};
		this.options = this.options || []
		this.options.map(option => {
			const label = Helpers.camelToTitleCase(option)
			this.checkBoxes.push({
				label,
				name: option,
				documentName: `${option}Document`,
				required: this.requiredFacilites[option],
				errorName: `${label} Document`,
			})
		})
		console.log(this.checkBoxes);

		const formGroup = this.options.reduce((fg, option) => {
			fg[option] = [false, []]
			fg[`${option}Document`] = ['', []]
			return fg;
		}, {});
		const fileValidation = [Validators.required,
		ValidationService.fileValidator,
		ValidationService.fileTypeValidator('pdf', 'jpeg', 'png', 'jpg'),
		ValidationService.fileSizeValidator(5)];
		this.facilitySelectUploadForm = this.formBuilder.group(formGroup);
		this.options.map(option => {
			this.facilitySelectUploadForm.controls[option].valueChanges.subscribe((value) => {
				if (value) {
					this.facilitySelectUploadForm.controls[`${option}Document`].setValidators([])
					// this.facilitySelectUploadForm.controls[`${option}Document`].setValue([]);
					this.facilitySelectUploadForm.controls[`${option}Document`].updateValueAndValidity();

				} else {
					this.facilitySelectUploadForm.controls[`${option}Document`].setValidators([]);
					this.facilitySelectUploadForm.controls[`${option}Document`].setValue([]);
					this.facilitySelectUploadForm.controls[`${option}Document`].updateValueAndValidity();
				}
			})
		})
		this.facilitySelectUploadForm.valueChanges.subscribe(value => {
			this.validChange.emit(this.facilitySelectUploadForm.valid);
			this.valueChange.emit({
				feebasedFacilities: this.facilitySelectUploadForm.getRawValue()
			});
		})
		this.validChange.emit(this.facilitySelectUploadForm.valid)

		this.patchValue(this.defaultValue);
		if (this.state === FORM_STATE.REVIEWING || this.disable) {
			this.options.map(option => {
				this.facilitySelectUploadForm.controls[`${option}`].disable();
				this.facilitySelectUploadForm.controls[`${option}Document`].disable();
			})
		} else {
			Object.keys(this.requiredFacilites).map(key => {
				this.facilitySelectUploadForm.controls[key].disable();
				this.facilitySelectUploadForm.controls[key].setValue(true)
			})
		}
	}

	get forDownload() {
		switch (this.state) {
			case FORM_STATE.REVIEWING: {
				return true;
			}
			case FORM_STATE.FILLING: {
				return false;
			}
			default: {
				return false;
			}
		}
	}
	ngOnChanges() {
		if (this.validationCheck) {
			this.sharedService.markFormGroupTouched(this.facilitySelectUploadForm);
		}
	}
}
